export default {
  /**
   * 当前域名
   */
  baseHost: '//www.infoq.cn/',
  /**
   * 极客时间企业版
   */
  bizHost: '//b.geekbang.org/',
  /**
   * 用户相关所用域名
   */
  accountHost: `//account.infoq.cn/`,
  /**
   * 账户中心的接口所用域名
   */
  account: '//account.geekbang.org/',
  /**
   * 极客时间域名
   */
  timeHost: '//time.geekbang.org',
  /**
   * cdn 地址域名
   */
  static001Host: '//static001.infoq.cn/',

  dataConcatStr: '<++++++>'
}
